import React from 'react';
import { inject } from 'mobx-react';
import HomeBanner from './home/banner';
import HomeMaintenanceModule from './home/maintenanceModule';
import HomeScheduleModule from './home/scheduleModule';
import { HomeBusiness } from '@business/newCreateRequest/common/home';
import { observer } from 'mobx-react-lite';
var NewRSPIndex = inject(HomeBusiness)(observer(function (props) {
    return React.createElement(React.Fragment, null,
        React.createElement(HomeBanner, null),
        React.createElement("div", { className: 'rsp-body' },
            React.createElement(HomeScheduleModule, null),
            React.createElement(HomeMaintenanceModule, null)));
}));
export default NewRSPIndex;
